module.exports = __webpack_public_path__ + "static/keyflow0-26545e708a7f079e6898bc0ad97b89b8.png";